<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <v-col cols="12">
      <base-material-card
        color="coolrunner"
        :icon="icon"
        inline
        class="px-5 py-3"
      >
        <template v-slot:after-heading>
          <div class="text-h2 font-weight-light">
            {{ $t('shipments') }}
          </div>
        </template>
        <v-data-table
          :items="items"
          :headers="headers"
          dense
          :loading="loading"
          :footer-props="{
            itemsPerPageOptions: []
          }"
          :options.sync="options"
          :server-items-length="totalItems"
        >
          <template v-slot:item.popup.refunded="{item}">
            <v-chip
              v-if="item.popup.refunded"
              color="red"
            >
              {{ $t('cancelled') }}
            </v-chip>
            <v-chip
              v-else
              color="green"
            >
              {{ $t('active') }}
            </v-chip>
          </template>

          <template v-slot:item.receiver_address="{item}">
            {{ item.receiver_street1 }}, {{ item.receiver_zip_code }} {{ item.receiver_city }}, {{ item.receiver_country }}
          </template>
          <template v-slot:item.created_at="{item}">
            {{ convertUTCToLocal(item.created_at) }}
          </template>
          <template v-slot:item.actions="{item}">
            <v-btn
              icon
              x-small
              :disabled="item.popup.refunded"
              @click="getLabel(item.reference)"
            >
              <v-icon
                color="green"
              >
                mdi-receipt
              </v-icon>
            </v-btn>
            <v-btn
              icon
              small
              :disabled="!item.popup.can_refund && !item.popup.refunded"
              @click="cancel(item.reference)"
            >
              <v-icon
                color="red"
                :size="24"
              >
                mdi-close
              </v-icon>
            </v-btn>
          </template>

          <template v-slot:body.prepend>
            <filter-row
              :filter-options="filterOptions"
              :headers="headers"
              :filter="filter"
              @set-filter="setFilter"
            />
          </template>
        </v-data-table>
      </base-material-card>
    </v-col>
    <base-loading-overlay :loading="loadingPdf" />
  </v-container>
</template>

<script>
  import List from '@/mixins/List'
  import { handleErrorResponse } from '@/plugins/data'
  import print from 'print-js'

  export default {
    mixins: [List],
    data () {
      return {
        endpoint: 'popup',
        loadingPdf: false,
        name: '',
        icon: 'mdi-truck-fast-outline',
        options: { itemsPerPage: 100 },
        headers: [
          {
            width: '1px',
            sortable: false,
            text: this.$t('cancelled'),
            value: 'popup.refunded',
          },
          {
            sortable: false,
            width: '1px',
            text: this.$t('package_number'),
            value: 'package_number',
          },
          {
            sortable: false,
            text: this.$t('reference'),
            value: 'reference',
          },
          {
            width: '1px',
            sortable: false,
            text: `${this.$t('sender')} ${this.$t('name')}`,
            value: 'sender.name',
          },
          {
            width: '1px',
            sortable: false,
            text: `${this.$t('receiver')} ${this.$t('name')}`,
            value: 'receiver.name',
          },
          {
            sortable: false,
            width: '1px',
            text: `${this.$t('created')}`,
            value: 'created_at',
          },
          { value: 'actions', width: '1px' },
        ],
        filterOptions: {
          package_number: {
            label: this.$t('package_number'),
            type: 'free',
            filter: '',
          },
          reference: {
            label: this.$t('reference'),
            type: 'free',
            filter: '',
          },
        },
        items: [],
      }
    },

    methods: {
      getLabel: function (ref) {
        this.loadingPdf = `${this.$t('fetching_label')}...`
        this.$get(`${this.endpoint}/${ref}/label`, {}, { responseType: 'blob' })
          .then(r => {
            print({
              printable: URL.createObjectURL(r.data),
              type: 'pdf',

              onPrintDialogClose: () => { this.loadingPdf = null },
              onPdfOpen: () => { this.loadingPdf = null },
              onError: handleErrorResponse,
            })
          })
          .catch(e => {
            this.loadingPdf = null
          })
      },
      cancel: function (ref) {
        if (confirm(this.$t('confirm_cancellation_entity', { entity: this.$t('label').toLowerCase() }))) {
          this.$del(`${this.endpoint}/${ref}/refund`, undefined).then(({ data }) => {
            if (!data.success) {
              this.$toast(data.message, { color: 'red' })
              return
            }

            this.$toast(`${this.$t('shipment')} ${this.$t('has_been_cancelled')}`)
            this.getDataFromApi()
          })
        }
      },
    },
  }
</script>
